"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _collapse = _interopRequireDefault(require("../../../core/collapse"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _submit = _interopRequireDefault(require("../../../core/submit"));
var _rowConfig = _interopRequireDefault(require("../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../core/label"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _inputOnBlur = _interopRequireDefault(require("../../../core/input-on-blur"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  isOpened: false,
  seasonStartDate: null,
  seasonEndDate: null
};
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Season Start Date*");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Season End Date*");
var _ref3 = /*#__PURE__*/_react.default.createElement(_submit.default, null, "Build Calendar");
class CreateCalendar extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onToggleOpen", () => {
      if (this.state.isOpened) return this.setState(initialState);
      this.setState({
        isOpened: true
      });
    });
    _defineProperty(this, "_validateStartDate", value => {
      if (this.props.lastYear && value <= this.props.lastYear.seasonEndDate) {
        return value + ' is before the last season ends on ' + this.props.lastYear.seasonEndDate;
      }
      return '';
    });
    _defineProperty(this, "_validateEndDate", value => {
      if (value && this.state.seasonStartDate >= value) {
        return 'Season End Date must be after the start date';
      }
      return '';
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      if (this._validateStartDate(this.state.seasonStartDate) || this._validateEndDate(this.state.seasonEndDate)) return;
      this.props.createCalendar(this.state.seasonStartDate, this.state.seasonEndDate);
    });
    _defineProperty(this, "_setValue", (value, field) => {
      this.setState({
        [field]: value
      });
    });
  }
  render() {
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleOpen
    }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onSubmit
    }, "Create"));
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleOpen
    }, this.state.isOpened ? 'Cancel Create' : 'Create Calendar'), /*#__PURE__*/_react.default.createElement(_collapse.default, {
      isOpened: this.state.isOpened
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-header"
    }, "Create Calendar For ", this.props.yearID, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Date",
      name: "seasonStartDate",
      value: this.state.seasonStartDate,
      onChange: this._setValue,
      required: true,
      customValidation: this._validateStartDate
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Date",
      name: "seasonEndDate",
      value: this.state.seasonEndDate,
      onChange: this._setValue,
      required: true,
      customValidation: this._validateEndDate
    })))), _ref3, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleOpen
    }, "Cancel")))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref4 = {
  seasonEndDate: true
};
var _default = exports.default = (0, _reactBicycle.connect)(CreateCalendar, props => ({
  ["calendar(yearID:" + JSON.stringify(+props.yearID - 1) + ") as lastYear"]: _ref4
}), (client, props) => ({
  createCalendar(seasonStartDate, seasonEndDate) {
    return client.update('Calendar.create', {
      yearID: +props.yearID,
      seasonStartDate,
      seasonEndDate
    });
  }
}));